import {
  createTheme,
  CSSVariablesResolver,
  MantineColorsTuple,
  MantineThemeOverride,
} from '@mantine/core';

const myColor: MantineColorsTuple = [
  '#eff2ff',
  '#dfe2f2',
  '#bdc2de',
  '#99a0ca',
  '#7a84b9',
  '#6672af',
  '#5c69ac',
  '#4c5897',
  '#424e88',
  '#36437a',
];

const customDark: MantineColorsTuple = [
  '#ADADAD', // Position 0 - Lightest shade, used for hover states on text
  '#8A8A8A', // Position 1 - Dimmed text, secondary text
  '#6C6C6C', // Position 2 - Borders, dividers
  '#424242', // Position 3 - Disabled elements
  '#303030', // Position 4 - Subtle backgrounds (e.g. hover states)
  '#242424', // Position 5 - Elements background (inputs, dropdowns)
  '#1D1D1D', // Position 6 - Cards, modals, popovers
  '#141414', // Position 7 - Page background
  '#101010', // Position 8 - Hover states (+contrast)
  '#050505', // Position 9 - Active states (+more contrast)
  '#020202', // Position 10 - Highest contrast elements
];

export const theme: MantineThemeOverride = createTheme({
  colors: {
    myColor,
    dark: customDark,
  },
  primaryColor: 'myColor',
});

export const cssVariablesResolver: CSSVariablesResolver = (theme_x) => {
  const colors = theme_x.colors;
  return {
    variables: {
      '--mantine-color-divider': '', // Placeholder, will be set below
      '--selected-card-bg': '',
      '--selected-card-border': '',
      '--deselected-card-border': '',
      '--deselected-card-hover-bg': '',
    },
    light: {
      '--subtle-bg': colors.gray[0],
      '--mantine-color-divider': colors.gray[3],
      '--selected-card-bg': colors.green[0],
      '--selected-card-border': colors.green[2],
      '--deselected-card-border': colors.gray[3],
      '--deselected-card-hover-bg': colors.gray[1],
    },
    dark: {
      '--subtle-bg': colors.dark[6],
      '--mantine-color-divider': colors.dark[2],
      '--selected-card-bg': colors.dark[9],
      '--selected-card-border': colors.green[7],
      '--deselected-card-border': colors.dark[3],
      '--deselected-card-hover-bg': colors.dark[5],
    },
  };
};
